export const getFlightTravelData = (data: any) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return [];
  }

  const generateDays = (numDays: number, overrideDays?: number) => {
    const days = overrideDays ?? numDays;
    return Array.from({ length: days }, (_, i) => `Day ${i + 1}`);
  };

  return data?.reduce((acc, city) => {
    if (!city || typeof city !== "object") {
      return acc;
    }

    const { flights } = city;

    if (!Array.isArray(flights) || flights?.length === 0) {
      return acc;
    }

    flights?.forEach((flight, index) => {
      if (!flight || typeof flight !== "object") {
        console.error("Invalid flight object: skipping.", flight);
        return;
      }

      const isSameDayFlight = index > 0 && flights[index - 1]?.dateInfo === flight.dateInfo;

      acc.push({
        departureCityAddress: flight?.departure_city_name || "",
        departureCountryCode: flight?.departure_city_country_code || "",
        departureLatitude: flight?.departure_city_latitude || null,
        departureLongitude: flight?.departure_city_longitude || null,
        arrivalCityAddress: flight?.arrival_city_name || "",
        arrivalCityCountryCode: flight?.arrival_city_country_code || "",
        arrivalLatitude: flight?.arrival_city_latitude || null,
        arrivalLongitude: flight?.arrival_city_longitude || null,
        departureDate: flight?.dateInfo,
        returnDate: "",
        days: generateDays(flight?.departureDay, isSameDayFlight ? 1 : undefined),
        totalDays: flight?.departureDay,
        flightTime: flight?.time_of_the_day || "",
      });
    });

    return acc;
  }, []);
};
